import Icon from 'Components/Icon';
import { useTranslation } from 'react-i18next';

interface IProps {
    message: string
}

const ErrorListItem = (props: IProps) => {
    const [t] = useTranslation()

    return (
        <div className="flex gap-2 px-6 py-3">
            <div id="alert-error" className="flex items-center p-3 text-white rounded-xl bg-gray-800 dark:bg-gray-800" role="alert">
                <div className="bg-error/[.16] text-error p-2 rounded-lg flex justify-center items-center">
                    <Icon name="ic_error" className="w-6 h-6" />
                </div>
                <span className="sr-only">error</span>
                <div className="ms-3 text-sm font-semibold grow">{t(props.message)}</div>
            </div>
        </div>
    );
}

export default ErrorListItem;